export default __webpack_public_path__ + "static/media/home-split-portfolio-img-04.02d9b1b0.jpg";